// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/dst/css/theme"], () => (__webpack_require__("./assets/src/js/app.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/dst/css/theme"], () => (__webpack_require__("./assets/src/sass/theme.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
